<template>
    <div class="main course">
        <div class="container">
            <div class="columns is-mobile">
                <div class="column has-text-left">
                    <h6 class="has-text-weight-bold">Hole {{ number }}: {{ name }}</h6>
                    {{ description }}<br>
                </div>
                <div class="column is-5 has-text-left">
                    <strong>Par:</strong> {{ par }}<br/>
                    <strong>Length:</strong> {{ length }} cm<br>
                </div>
                <!-- <div class="column is-3">
                    <img alt="Golf Course" :src="require('@/assets/' + number + '.png')" style="height:100px;">
                </div> -->
            </div>
        </div>
        <!-- <div class="container">
            <div class="columns is-mobile">
                <div class="column has-text-left">
                    <a href="#">Prev</a>
                </div>
                <div class="column is-3">
                    <a href="#">Next</a>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default {
        name: "Course",
        props: {
            number: Number,
            description: String,
            name: String,
            par: Number,
            length: Number
        }
    }
</script>

<style lang="scss" scoped>
    .main {
        padding: 20px;
        background: #f5f5f5;
    }

    .course {
        font-size: 0.8em;
    }
</style>